// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/artifact/v1/artifact.proto (package mono.artifact.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Struct, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from enum mono.artifact.v1.ArtifactStatus
 */ export var ArtifactStatus = /*#__PURE__*/ function(ArtifactStatus) {
    /**
   * @generated from enum value: ARTIFACT_STATUS_UNSPECIFIED = 0;
   */ ArtifactStatus[ArtifactStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: ARTIFACT_STATUS_UPLOADING = 1;
   */ ArtifactStatus[ArtifactStatus["UPLOADING"] = 1] = "UPLOADING";
    /**
   * @generated from enum value: ARTIFACT_STATUS_UPLOADED = 2;
   */ ArtifactStatus[ArtifactStatus["UPLOADED"] = 2] = "UPLOADED";
    /**
   * @generated from enum value: ARTIFACT_STATUS_PROCESSING = 3;
   */ ArtifactStatus[ArtifactStatus["PROCESSING"] = 3] = "PROCESSING";
    /**
   * @generated from enum value: ARTIFACT_STATUS_READY = 4;
   */ ArtifactStatus[ArtifactStatus["READY"] = 4] = "READY";
    /**
   * @generated from enum value: ARTIFACT_STATUS_FAILED = 5;
   */ ArtifactStatus[ArtifactStatus["FAILED"] = 5] = "FAILED";
    /**
   * @generated from enum value: ARTIFACT_STATUS_DELETED = 6;
   */ ArtifactStatus[ArtifactStatus["DELETED"] = 6] = "DELETED";
    return ArtifactStatus;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ArtifactStatus)
proto3.util.setEnumType(ArtifactStatus, "mono.artifact.v1.ArtifactStatus", [
    {
        no: 0,
        name: "ARTIFACT_STATUS_UNSPECIFIED"
    },
    {
        no: 1,
        name: "ARTIFACT_STATUS_UPLOADING"
    },
    {
        no: 2,
        name: "ARTIFACT_STATUS_UPLOADED"
    },
    {
        no: 3,
        name: "ARTIFACT_STATUS_PROCESSING"
    },
    {
        no: 4,
        name: "ARTIFACT_STATUS_READY"
    },
    {
        no: 5,
        name: "ARTIFACT_STATUS_FAILED"
    },
    {
        no: 6,
        name: "ARTIFACT_STATUS_DELETED"
    }
]);
/**
 * @generated from enum mono.artifact.v1.ProcessingStatus
 */ export var ProcessingStatus = /*#__PURE__*/ function(ProcessingStatus) {
    /**
   * @generated from enum value: PROCESSING_STATUS_UNSPECIFIED = 0;
   */ ProcessingStatus[ProcessingStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: PROCESSING_STATUS_QUEUED = 1;
   */ ProcessingStatus[ProcessingStatus["QUEUED"] = 1] = "QUEUED";
    /**
   * @generated from enum value: PROCESSING_STATUS_RUNNING = 2;
   */ ProcessingStatus[ProcessingStatus["RUNNING"] = 2] = "RUNNING";
    /**
   * @generated from enum value: PROCESSING_STATUS_COMPLETED = 3;
   */ ProcessingStatus[ProcessingStatus["COMPLETED"] = 3] = "COMPLETED";
    /**
   * @generated from enum value: PROCESSING_STATUS_FAILED = 4;
   */ ProcessingStatus[ProcessingStatus["FAILED"] = 4] = "FAILED";
    /**
   * @generated from enum value: PROCESSING_STATUS_CANCELLED = 5;
   */ ProcessingStatus[ProcessingStatus["CANCELLED"] = 5] = "CANCELLED";
    return ProcessingStatus;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ProcessingStatus)
proto3.util.setEnumType(ProcessingStatus, "mono.artifact.v1.ProcessingStatus", [
    {
        no: 0,
        name: "PROCESSING_STATUS_UNSPECIFIED"
    },
    {
        no: 1,
        name: "PROCESSING_STATUS_QUEUED"
    },
    {
        no: 2,
        name: "PROCESSING_STATUS_RUNNING"
    },
    {
        no: 3,
        name: "PROCESSING_STATUS_COMPLETED"
    },
    {
        no: 4,
        name: "PROCESSING_STATUS_FAILED"
    },
    {
        no: 5,
        name: "PROCESSING_STATUS_CANCELLED"
    }
]);
/**
 * @generated from enum mono.artifact.v1.StorageProvider
 */ export var StorageProvider = /*#__PURE__*/ function(StorageProvider) {
    /**
   * @generated from enum value: STORAGE_PROVIDER_UNSPECIFIED = 0;
   */ StorageProvider[StorageProvider["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: STORAGE_PROVIDER_MINIO = 1;
   */ StorageProvider[StorageProvider["MINIO"] = 1] = "MINIO";
    return StorageProvider;
}({});
// Retrieve enum metadata with: proto3.getEnumType(StorageProvider)
proto3.util.setEnumType(StorageProvider, "mono.artifact.v1.StorageProvider", [
    {
        no: 0,
        name: "STORAGE_PROVIDER_UNSPECIFIED"
    },
    {
        no: 1,
        name: "STORAGE_PROVIDER_MINIO"
    }
]);
/**
 * @generated from enum mono.artifact.v1.ArtifactFileCategory
 */ export var ArtifactFileCategory = /*#__PURE__*/ function(ArtifactFileCategory) {
    /**
   * @generated from enum value: ARTIFACT_FILE_CATEGORY_UNSPECIFIED = 0;
   */ ArtifactFileCategory[ArtifactFileCategory["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: ARTIFACT_FILE_CATEGORY_SOURCE_DOCUMENT = 1;
   */ ArtifactFileCategory[ArtifactFileCategory["SOURCE_DOCUMENT"] = 1] = "SOURCE_DOCUMENT";
    /**
   * @generated from enum value: ARTIFACT_FILE_CATEGORY_PROJECT_FILE = 2;
   */ ArtifactFileCategory[ArtifactFileCategory["PROJECT_FILE"] = 2] = "PROJECT_FILE";
    return ArtifactFileCategory;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ArtifactFileCategory)
proto3.util.setEnumType(ArtifactFileCategory, "mono.artifact.v1.ArtifactFileCategory", [
    {
        no: 0,
        name: "ARTIFACT_FILE_CATEGORY_UNSPECIFIED"
    },
    {
        no: 1,
        name: "ARTIFACT_FILE_CATEGORY_SOURCE_DOCUMENT"
    },
    {
        no: 2,
        name: "ARTIFACT_FILE_CATEGORY_PROJECT_FILE"
    }
]);
/**
 * @generated from enum mono.artifact.v1.ArtifactSourceKind
 */ export var ArtifactSourceKind = /*#__PURE__*/ function(ArtifactSourceKind) {
    /**
   * @generated from enum value: ARTIFACT_SOURCE_KIND_UNSPECIFIED = 0;
   */ ArtifactSourceKind[ArtifactSourceKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: ARTIFACT_SOURCE_KIND_SOLICITATION = 1;
   */ ArtifactSourceKind[ArtifactSourceKind["SOLICITATION"] = 1] = "SOLICITATION";
    /**
   * @generated from enum value: ARTIFACT_SOURCE_KIND_AMENDMENT = 2;
   */ ArtifactSourceKind[ArtifactSourceKind["AMENDMENT"] = 2] = "AMENDMENT";
    /**
   * @generated from enum value: ARTIFACT_SOURCE_KIND_QA = 3;
   */ ArtifactSourceKind[ArtifactSourceKind["QA"] = 3] = "QA";
    /**
   * @generated from enum value: ARTIFACT_SOURCE_KIND_ATTACHMENT = 4;
   */ ArtifactSourceKind[ArtifactSourceKind["ATTACHMENT"] = 4] = "ATTACHMENT";
    /**
   * @generated from enum value: ARTIFACT_SOURCE_KIND_CONTRACT_MOD = 5;
   */ ArtifactSourceKind[ArtifactSourceKind["CONTRACT_MOD"] = 5] = "CONTRACT_MOD";
    return ArtifactSourceKind;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ArtifactSourceKind)
proto3.util.setEnumType(ArtifactSourceKind, "mono.artifact.v1.ArtifactSourceKind", [
    {
        no: 0,
        name: "ARTIFACT_SOURCE_KIND_UNSPECIFIED"
    },
    {
        no: 1,
        name: "ARTIFACT_SOURCE_KIND_SOLICITATION"
    },
    {
        no: 2,
        name: "ARTIFACT_SOURCE_KIND_AMENDMENT"
    },
    {
        no: 3,
        name: "ARTIFACT_SOURCE_KIND_QA"
    },
    {
        no: 4,
        name: "ARTIFACT_SOURCE_KIND_ATTACHMENT"
    },
    {
        no: 5,
        name: "ARTIFACT_SOURCE_KIND_CONTRACT_MOD"
    }
]);
/**
 * @generated from message mono.artifact.v1.Artifact
 */ export class Artifact extends Message {
    static fromBinary(bytes, options) {
        return new Artifact().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Artifact().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Artifact().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Artifact, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string owner_user_id = 3;
   */ _define_property(this, "ownerUserId", ""), /**
   * optional
   *
   * @generated from field: string project_id = 4;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string filename = 5;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 6;
   */ _define_property(this, "mimeType", ""), /**
   * @generated from field: int64 size_bytes = 7;
   */ _define_property(this, "sizeBytes", protoInt64.zero), /**
   * @generated from field: string checksum_sha256 = 8;
   */ _define_property(this, "checksumSha256", ""), /**
   * @generated from field: mono.artifact.v1.StorageProvider storage_provider = 9;
   */ _define_property(this, "storageProvider", 0), /**
   * @generated from field: string storage_bucket = 10;
   */ _define_property(this, "storageBucket", ""), /**
   * @generated from field: string storage_key = 11;
   */ _define_property(this, "storageKey", ""), /**
   * @generated from field: mono.artifact.v1.ArtifactStatus status = 12;
   */ _define_property(this, "status", 0), /**
   * Classification fields lifted from the legacy Attachment model.
   *
   * @generated from field: mono.artifact.v1.ArtifactFileCategory file_category = 13;
   */ _define_property(this, "fileCategory", 0), /**
   * @generated from field: mono.artifact.v1.ArtifactSourceKind source_kind = 14;
   */ _define_property(this, "sourceKind", 0), /**
   * free-form ("source"|"amendment"|"reference"...)
   *
   * @generated from field: string document_type = 15;
   */ _define_property(this, "documentType", ""), /**
   * @generated from field: string classification_label = 16;
   */ _define_property(this, "classificationLabel", ""), /**
   * @generated from field: int32 page_count = 17;
   */ _define_property(this, "pageCount", 0), /**
   * @generated from field: string chat_id = 18;
   */ _define_property(this, "chatId", ""), /**
   * @generated from field: string message_id = 19;
   */ _define_property(this, "messageId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 20;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 21;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 22;
   */ _define_property(this, "deletedAt", void 0), /**
   * @generated from field: int32 version = 23;
   */ _define_property(this, "version", 0), /**
   * Catalog labels explain filename abbreviations; the original identity is unchanged.
   *
   * @generated from field: string display_title = 24;
   */ _define_property(this, "displayTitle", ""), /**
   * @generated from field: repeated string keywords = 25;
   */ _define_property(this, "keywords", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Artifact, "runtime", proto3);
_define_property(Artifact, "typeName", "mono.artifact.v1.Artifact");
_define_property(Artifact, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "size_bytes",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 8,
            name: "checksum_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "storage_provider",
            kind: "enum",
            T: proto3.getEnumType(StorageProvider)
        },
        {
            no: 10,
            name: "storage_bucket",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "storage_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "status",
            kind: "enum",
            T: proto3.getEnumType(ArtifactStatus)
        },
        {
            no: 13,
            name: "file_category",
            kind: "enum",
            T: proto3.getEnumType(ArtifactFileCategory)
        },
        {
            no: 14,
            name: "source_kind",
            kind: "enum",
            T: proto3.getEnumType(ArtifactSourceKind)
        },
        {
            no: 15,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "classification_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "page_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 18,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "message_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 21,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 22,
            name: "deleted_at",
            kind: "message",
            T: Timestamp,
            opt: true
        },
        {
            no: 23,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 24,
            name: "display_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "keywords",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.artifact.v1.ProcessingJob
 */ export class ProcessingJob extends Message {
    static fromBinary(bytes, options) {
        return new ProcessingJob().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProcessingJob().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProcessingJob().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProcessingJob, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string job_id = 1;
   */ _define_property(this, "jobId", ""), /**
   * @generated from field: string artifact_id = 2;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string requested_by_user_id = 4;
   */ _define_property(this, "requestedByUserId", ""), /**
   * processor identifies the executing service ("reverie" today).
   *
   * @generated from field: string processor = 5;
   */ _define_property(this, "processor", ""), /**
   * @generated from field: mono.artifact.v1.ProcessingStatus status = 6;
   */ _define_property(this, "status", 0), /**
   * @generated from field: int32 progress_percent = 7;
   */ _define_property(this, "progressPercent", 0), /**
   * @generated from field: string current_step = 8;
   */ _define_property(this, "currentStep", ""), /**
   * @generated from field: string error_message = 9;
   */ _define_property(this, "errorMessage", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 12;
   */ _define_property(this, "completedAt", void 0), /**
   * Estimated wall-clock seconds until completion. 0 = unknown (no historical
   * baseline yet, or the processor hasn't reported one). Frontends should
   * fall back to an elapsed-time display when this is 0.
   *
   * @generated from field: int32 estimated_remaining_seconds = 13;
   */ _define_property(this, "estimatedRemainingSeconds", 0), /**
   * Echoes the options the job was launched with. Surfaced so frontends and
   * operators can confirm what the worker is actually running.
   *
   * @generated from field: google.protobuf.Struct processing_options = 14;
   */ _define_property(this, "processingOptions", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProcessingJob, "runtime", proto3);
_define_property(ProcessingJob, "typeName", "mono.artifact.v1.ProcessingJob");
_define_property(ProcessingJob, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "requested_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "processor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "status",
            kind: "enum",
            T: proto3.getEnumType(ProcessingStatus)
        },
        {
            no: 7,
            name: "progress_percent",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "current_step",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "error_message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "completed_at",
            kind: "message",
            T: Timestamp,
            opt: true
        },
        {
            no: 13,
            name: "estimated_remaining_seconds",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 14,
            name: "processing_options",
            kind: "message",
            T: Struct
        }
    ]));
/**
 * @generated from message mono.artifact.v1.ArtifactFilter
 */ export class ArtifactFilter extends Message {
    static fromBinary(bytes, options) {
        return new ArtifactFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ArtifactFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ArtifactFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ArtifactFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: mono.artifact.v1.ArtifactStatus status = 2;
   */ _define_property(this, "status", 0), /**
   * @generated from field: string document_type = 3;
   */ _define_property(this, "documentType", ""), /**
   * @generated from field: mono.artifact.v1.ArtifactFileCategory file_category = 4;
   */ _define_property(this, "fileCategory", 0), /**
   * @generated from field: mono.artifact.v1.ArtifactSourceKind source_kind = 5;
   */ _define_property(this, "sourceKind", 0), /**
   * @generated from field: string owner_user_id = 6;
   */ _define_property(this, "ownerUserId", ""), /**
   * @generated from field: string chat_id = 7;
   */ _define_property(this, "chatId", ""), /**
   * @generated from field: optional google.protobuf.Timestamp created_after = 8;
   */ _define_property(this, "createdAfter", void 0), /**
   * @generated from field: optional google.protobuf.Timestamp created_before = 9;
   */ _define_property(this, "createdBefore", void 0), /**
   * @generated from field: bool include_deleted = 10;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ArtifactFilter, "runtime", proto3);
_define_property(ArtifactFilter, "typeName", "mono.artifact.v1.ArtifactFilter");
_define_property(ArtifactFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "enum",
            T: proto3.getEnumType(ArtifactStatus)
        },
        {
            no: 3,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "file_category",
            kind: "enum",
            T: proto3.getEnumType(ArtifactFileCategory)
        },
        {
            no: 5,
            name: "source_kind",
            kind: "enum",
            T: proto3.getEnumType(ArtifactSourceKind)
        },
        {
            no: 6,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_after",
            kind: "message",
            T: Timestamp,
            opt: true
        },
        {
            no: 9,
            name: "created_before",
            kind: "message",
            T: Timestamp,
            opt: true
        },
        {
            no: 10,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.CreateUploadSessionRequest
 */ export class CreateUploadSessionRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateUploadSessionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateUploadSessionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateUploadSessionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateUploadSessionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string owner_user_id = 2;
   */ _define_property(this, "ownerUserId", ""), /**
   * optional
   *
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", ""), /**
   * optional
   *
   * @generated from field: string chat_id = 4;
   */ _define_property(this, "chatId", ""), /**
   * optional
   *
   * @generated from field: string message_id = 5;
   */ _define_property(this, "messageId", ""), /**
   * @generated from field: string filename = 6;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 7;
   */ _define_property(this, "mimeType", ""), /**
   * hint; CompleteUpload re-validates against MinIO
   *
   * @generated from field: int64 size_bytes = 8;
   */ _define_property(this, "sizeBytes", protoInt64.zero), /**
   * Pre-classification (optional). When set, the row is created with these
   * fields populated so consumers don't have to fan out to a second update.
   *
   * @generated from field: mono.artifact.v1.ArtifactFileCategory file_category = 9;
   */ _define_property(this, "fileCategory", 0), /**
   * @generated from field: mono.artifact.v1.ArtifactSourceKind source_kind = 10;
   */ _define_property(this, "sourceKind", 0), /**
   * @generated from field: string document_type = 11;
   */ _define_property(this, "documentType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateUploadSessionRequest, "runtime", proto3);
_define_property(CreateUploadSessionRequest, "typeName", "mono.artifact.v1.CreateUploadSessionRequest");
_define_property(CreateUploadSessionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "message_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "size_bytes",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 9,
            name: "file_category",
            kind: "enum",
            T: proto3.getEnumType(ArtifactFileCategory)
        },
        {
            no: 10,
            name: "source_kind",
            kind: "enum",
            T: proto3.getEnumType(ArtifactSourceKind)
        },
        {
            no: 11,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.CreateUploadSessionResponse
 */ export class CreateUploadSessionResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateUploadSessionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateUploadSessionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateUploadSessionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateUploadSessionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string upload_id = 1;
   */ _define_property(this, "uploadId", ""), /**
   * @generated from field: string artifact_id = 2;
   */ _define_property(this, "artifactId", ""), /**
   * presigned PUT URL for MinIO
   *
   * @generated from field: string upload_url = 3;
   */ _define_property(this, "uploadUrl", ""), /**
   * @generated from field: google.protobuf.Timestamp expires_at = 4;
   */ _define_property(this, "expiresAt", void 0), /**
   * The bucket+key the URL targets — clients with direct MinIO access can use
   * these instead of the URL.
   *
   * @generated from field: string storage_bucket = 5;
   */ _define_property(this, "storageBucket", ""), /**
   * @generated from field: string storage_key = 6;
   */ _define_property(this, "storageKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateUploadSessionResponse, "runtime", proto3);
_define_property(CreateUploadSessionResponse, "typeName", "mono.artifact.v1.CreateUploadSessionResponse");
_define_property(CreateUploadSessionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "upload_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "upload_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "expires_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "storage_bucket",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "storage_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.CreateInternalArtifactRequest
 */ export class CreateInternalArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateInternalArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateInternalArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateInternalArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateInternalArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * optional — principal's tenant wins if both set
   *
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string owner_user_id = 2;
   */ _define_property(this, "ownerUserId", ""), /**
   * optional
   *
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", ""), /**
   * optional
   *
   * @generated from field: string chat_id = 4;
   */ _define_property(this, "chatId", ""), /**
   * optional
   *
   * @generated from field: string message_id = 5;
   */ _define_property(this, "messageId", ""), /**
   * @generated from field: string filename = 6;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 7;
   */ _define_property(this, "mimeType", ""), /**
   * Raw bytes. Tesoro performs the MinIO write inline and lands the
   * artifact in status=UPLOADED.
   *
   * @generated from field: bytes data = 8;
   */ _define_property(this, "data", new Uint8Array(0)), /**
   * Optional client-computed checksum recorded as-is (tesoro does NOT
   * verify; the inline write means content matches by construction).
   *
   * @generated from field: string checksum_sha256 = 9;
   */ _define_property(this, "checksumSha256", ""), /**
   * Pre-classification (mirrors CreateUploadSessionRequest).
   *
   * @generated from field: mono.artifact.v1.ArtifactFileCategory file_category = 10;
   */ _define_property(this, "fileCategory", 0), /**
   * @generated from field: mono.artifact.v1.ArtifactSourceKind source_kind = 11;
   */ _define_property(this, "sourceKind", 0), /**
   * @generated from field: string document_type = 12;
   */ _define_property(this, "documentType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateInternalArtifactRequest, "runtime", proto3);
_define_property(CreateInternalArtifactRequest, "typeName", "mono.artifact.v1.CreateInternalArtifactRequest");
_define_property(CreateInternalArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "message_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 9,
            name: "checksum_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "file_category",
            kind: "enum",
            T: proto3.getEnumType(ArtifactFileCategory)
        },
        {
            no: 11,
            name: "source_kind",
            kind: "enum",
            T: proto3.getEnumType(ArtifactSourceKind)
        },
        {
            no: 12,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.CreateInternalArtifactResponse
 */ export class CreateInternalArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateInternalArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateInternalArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateInternalArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateInternalArtifactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.artifact.v1.Artifact artifact = 1;
   */ _define_property(this, "artifact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateInternalArtifactResponse, "runtime", proto3);
_define_property(CreateInternalArtifactResponse, "typeName", "mono.artifact.v1.CreateInternalArtifactResponse");
_define_property(CreateInternalArtifactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: Artifact
        }
    ]));
/**
 * @generated from message mono.artifact.v1.PromoteChatArtifactRequest
 */ export class PromoteChatArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new PromoteChatArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PromoteChatArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PromoteChatArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PromoteChatArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Source artifact id (typically a chat upload with chat_id set).
   *
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * Delivery program the promoted copy will be attached to. Required when the
   * source still has chat_id — gates program update before the copy is minted.
   *
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * Optional zou project id for mod / Docs project-file lanes. Empty keeps the
   * drawer shape (unattached MinIO key + Delivery FK binding).
   *
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PromoteChatArtifactRequest, "runtime", proto3);
_define_property(PromoteChatArtifactRequest, "typeName", "mono.artifact.v1.PromoteChatArtifactRequest");
_define_property(PromoteChatArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.PromoteChatArtifactResponse
 */ export class PromoteChatArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new PromoteChatArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PromoteChatArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PromoteChatArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PromoteChatArtifactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * The program-scoped copy, or the source when it was already non-chat.
   *
   * @generated from field: mono.artifact.v1.Artifact artifact = 1;
   */ _define_property(this, "artifact", void 0), /**
   * True when artifact_id already had no chat_id and was returned unchanged.
   *
   * @generated from field: bool already_program_scoped = 2;
   */ _define_property(this, "alreadyProgramScoped", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PromoteChatArtifactResponse, "runtime", proto3);
_define_property(PromoteChatArtifactResponse, "typeName", "mono.artifact.v1.PromoteChatArtifactResponse");
_define_property(PromoteChatArtifactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: Artifact
        },
        {
            no: 2,
            name: "already_program_scoped",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.CompleteUploadRequest
 */ export class CompleteUploadRequest extends Message {
    static fromBinary(bytes, options) {
        return new CompleteUploadRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompleteUploadRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompleteUploadRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompleteUploadRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string upload_id = 1;
   */ _define_property(this, "uploadId", ""), /**
   * Optional client-computed checksum; tesoro records it as-is. tesoro also
   * independently fetches the object's ETag from MinIO to verify presence.
   *
   * @generated from field: string checksum_sha256 = 2;
   */ _define_property(this, "checksumSha256", ""), /**
   * When true, tesoro also calls StartArtifactProcessing in the same request.
   *
   * @generated from field: bool auto_process = 3;
   */ _define_property(this, "autoProcess", false), /**
   * Forwarded to reverie's ProcessDocumentRequest.options when auto_process=true.
   * Same accepted keys as etl.v1.ProcessDocumentRequest.options.
   *
   * @generated from field: google.protobuf.Struct processing_options = 4;
   */ _define_property(this, "processingOptions", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompleteUploadRequest, "runtime", proto3);
_define_property(CompleteUploadRequest, "typeName", "mono.artifact.v1.CompleteUploadRequest");
_define_property(CompleteUploadRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "upload_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "checksum_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "auto_process",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "processing_options",
            kind: "message",
            T: Struct
        }
    ]));
/**
 * @generated from message mono.artifact.v1.CompleteUploadResponse
 */ export class CompleteUploadResponse extends Message {
    static fromBinary(bytes, options) {
        return new CompleteUploadResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompleteUploadResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompleteUploadResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompleteUploadResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.artifact.v1.Artifact artifact = 1;
   */ _define_property(this, "artifact", void 0), /**
   * Populated only when auto_process=true and the reverie call succeeded.
   *
   * @generated from field: string processing_job_id = 2;
   */ _define_property(this, "processingJobId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompleteUploadResponse, "runtime", proto3);
_define_property(CompleteUploadResponse, "typeName", "mono.artifact.v1.CompleteUploadResponse");
_define_property(CompleteUploadResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: Artifact
        },
        {
            no: 2,
            name: "processing_job_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.AbortUploadRequest
 */ export class AbortUploadRequest extends Message {
    static fromBinary(bytes, options) {
        return new AbortUploadRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AbortUploadRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AbortUploadRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AbortUploadRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string upload_id = 1;
   */ _define_property(this, "uploadId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AbortUploadRequest, "runtime", proto3);
_define_property(AbortUploadRequest, "typeName", "mono.artifact.v1.AbortUploadRequest");
_define_property(AbortUploadRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "upload_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.AbortUploadResponse
 */ export class AbortUploadResponse extends Message {
    static fromBinary(bytes, options) {
        return new AbortUploadResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AbortUploadResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AbortUploadResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AbortUploadResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.artifact.v1.Artifact artifact = 1;
   */ _define_property(this, "artifact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AbortUploadResponse, "runtime", proto3);
_define_property(AbortUploadResponse, "typeName", "mono.artifact.v1.AbortUploadResponse");
_define_property(AbortUploadResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: Artifact
        }
    ]));
/**
 * @generated from message mono.artifact.v1.ExpandArchiveArtifactRequest
 */ export class ExpandArchiveArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExpandArchiveArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExpandArchiveArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExpandArchiveArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExpandArchiveArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * When true, each extracted child is immediately handed to processing
   * (equivalent to StartArtifactProcessing), the same way CompleteUpload's
   * auto_process fans out to a single artifact. Defaults to false — children
   * are created in status=UPLOADED and left for the caller to process
   * explicitly. Same opt-in-by-default rule as CompleteUpload, so this RPC
   * doesn't surprise a caller who only wants the archive split apart.
   *
   * @generated from field: bool auto_process = 2;
   */ _define_property(this, "autoProcess", false), /**
   * Forwarded to each child's processing job when auto_process=true. Same
   * accepted keys as etl.v1.ProcessDocumentRequest.options.
   *
   * @generated from field: google.protobuf.Struct processing_options = 3;
   */ _define_property(this, "processingOptions", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExpandArchiveArtifactRequest, "runtime", proto3);
_define_property(ExpandArchiveArtifactRequest, "typeName", "mono.artifact.v1.ExpandArchiveArtifactRequest");
_define_property(ExpandArchiveArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "auto_process",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "processing_options",
            kind: "message",
            T: Struct
        }
    ]));
/**
 * ExpandedChildArtifact is one member extracted from the archive and
 * persisted as its own artifact row.
 *
 * @generated from message mono.artifact.v1.ExpandedChildArtifact
 */ export class ExpandedChildArtifact extends Message {
    static fromBinary(bytes, options) {
        return new ExpandedChildArtifact().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExpandedChildArtifact().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExpandedChildArtifact().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExpandedChildArtifact, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * The readable display name (ziputil disambiguates members that share a
   * base filename across folders) — not necessarily the full in-archive path.
   *
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 3;
   */ _define_property(this, "mimeType", ""), /**
   * @generated from field: int64 size_bytes = 4;
   */ _define_property(this, "sizeBytes", protoInt64.zero), /**
   * SHA-256 of the member's bytes as extracted — the byte-identity oracle
   * callers can check the child against.
   *
   * @generated from field: string checksum_sha256 = 5;
   */ _define_property(this, "checksumSha256", ""), /**
   * Empty when processing kick-off failed for this child (logged
   * server-side); the child artifact still exists in status=UPLOADED and
   * can be processed later via StartArtifactProcessing.
   *
   * @generated from field: string processing_job_id = 6;
   */ _define_property(this, "processingJobId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExpandedChildArtifact, "runtime", proto3);
_define_property(ExpandedChildArtifact, "typeName", "mono.artifact.v1.ExpandedChildArtifact");
_define_property(ExpandedChildArtifact, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "size_bytes",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "checksum_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "processing_job_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * SkippedArchiveMember is one member that did not become a child artifact,
 * with a human-readable reason (ziputil's own skip-reason strings — unsupported
 * type, nested archive, oversize, duplicate, metadata file, unreadable).
 *
 * @generated from message mono.artifact.v1.SkippedArchiveMember
 */ export class SkippedArchiveMember extends Message {
    static fromBinary(bytes, options) {
        return new SkippedArchiveMember().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SkippedArchiveMember().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SkippedArchiveMember().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SkippedArchiveMember, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string path = 1;
   */ _define_property(this, "path", ""), /**
   * @generated from field: string reason = 2;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SkippedArchiveMember, "runtime", proto3);
_define_property(SkippedArchiveMember, "typeName", "mono.artifact.v1.SkippedArchiveMember");
_define_property(SkippedArchiveMember, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.ExpandArchiveArtifactResponse
 */ export class ExpandArchiveArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExpandArchiveArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExpandArchiveArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExpandArchiveArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExpandArchiveArtifactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.artifact.v1.ExpandedChildArtifact children = 1;
   */ _define_property(this, "children", []), /**
   * @generated from field: repeated mono.artifact.v1.SkippedArchiveMember skipped = 2;
   */ _define_property(this, "skipped", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExpandArchiveArtifactResponse, "runtime", proto3);
_define_property(ExpandArchiveArtifactResponse, "typeName", "mono.artifact.v1.ExpandArchiveArtifactResponse");
_define_property(ExpandArchiveArtifactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "children",
            kind: "message",
            T: ExpandedChildArtifact,
            repeated: true
        },
        {
            no: 2,
            name: "skipped",
            kind: "message",
            T: SkippedArchiveMember,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.artifact.v1.GetArtifactRequest
 */ export class GetArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetArtifactRequest, "runtime", proto3);
_define_property(GetArtifactRequest, "typeName", "mono.artifact.v1.GetArtifactRequest");
_define_property(GetArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.GetArtifactResponse
 */ export class GetArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetArtifactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.artifact.v1.Artifact artifact = 1;
   */ _define_property(this, "artifact", void 0), /**
   * Current caller's explicit source export authorization. Read/download,
   * ownership and a linked Program never imply external-output permission.
   * Missing/unknown policy decisions are false; consumers must recheck at export.
   *
   * @generated from field: bool external_output_eligible = 2;
   */ _define_property(this, "externalOutputEligible", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetArtifactResponse, "runtime", proto3);
_define_property(GetArtifactResponse, "typeName", "mono.artifact.v1.GetArtifactResponse");
_define_property(GetArtifactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: Artifact
        },
        {
            no: 2,
            name: "external_output_eligible",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.ListArtifactsRequest
 */ export class ListArtifactsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListArtifactsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListArtifactsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListArtifactsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListArtifactsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: mono.artifact.v1.ArtifactFilter filter = 2;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 3;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 4;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListArtifactsRequest, "runtime", proto3);
_define_property(ListArtifactsRequest, "typeName", "mono.artifact.v1.ListArtifactsRequest");
_define_property(ListArtifactsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filter",
            kind: "message",
            T: ArtifactFilter
        },
        {
            no: 3,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.ListArtifactsResponse
 */ export class ListArtifactsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListArtifactsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListArtifactsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListArtifactsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListArtifactsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.artifact.v1.Artifact artifacts = 1;
   */ _define_property(this, "artifacts", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListArtifactsResponse, "runtime", proto3);
_define_property(ListArtifactsResponse, "typeName", "mono.artifact.v1.ListArtifactsResponse");
_define_property(ListArtifactsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifacts",
            kind: "message",
            T: Artifact,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.FindArtifactsByChecksumRequest
 */ export class FindArtifactsByChecksumRequest extends Message {
    static fromBinary(bytes, options) {
        return new FindArtifactsByChecksumRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FindArtifactsByChecksumRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FindArtifactsByChecksumRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FindArtifactsByChecksumRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string checksum_sha256 = 1;
   */ _define_property(this, "checksumSha256", ""), /**
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0), /**
   * Drop this artifact from the match set (the file being planned).
   *
   * @generated from field: string exclude_artifact_id = 3;
   */ _define_property(this, "excludeArtifactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FindArtifactsByChecksumRequest, "runtime", proto3);
_define_property(FindArtifactsByChecksumRequest, "typeName", "mono.artifact.v1.FindArtifactsByChecksumRequest");
_define_property(FindArtifactsByChecksumRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "checksum_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "exclude_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ChecksumFiling is one place a same-bytes artifact the caller can see is filed.
 *
 * @generated from message mono.artifact.v1.ChecksumFiling
 */ export class ChecksumFiling extends Message {
    static fromBinary(bytes, options) {
        return new ChecksumFiling().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChecksumFiling().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChecksumFiling().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChecksumFiling, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * program_document | submission | quality | project
   *
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string program_id = 4;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string program_name = 5;
   */ _define_property(this, "programName", ""), /**
   * delivery.program_documents id when kind is program_document.
   *
   * @generated from field: string program_document_id = 6;
   */ _define_property(this, "programDocumentId", ""), /**
   * @generated from field: string project_id = 7;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ChecksumFiling, "runtime", proto3);
_define_property(ChecksumFiling, "typeName", "mono.artifact.v1.ChecksumFiling");
_define_property(ChecksumFiling, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "program_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "program_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.FindArtifactsByChecksumResponse
 */ export class FindArtifactsByChecksumResponse extends Message {
    static fromBinary(bytes, options) {
        return new FindArtifactsByChecksumResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FindArtifactsByChecksumResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FindArtifactsByChecksumResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FindArtifactsByChecksumResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.artifact.v1.ChecksumFiling filings = 1;
   */ _define_property(this, "filings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FindArtifactsByChecksumResponse, "runtime", proto3);
_define_property(FindArtifactsByChecksumResponse, "typeName", "mono.artifact.v1.FindArtifactsByChecksumResponse");
_define_property(FindArtifactsByChecksumResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filings",
            kind: "message",
            T: ChecksumFiling,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.artifact.v1.DeleteArtifactRequest
 */ export class DeleteArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * When true, both the metadata row AND the underlying MinIO object are
   * removed. Default false = soft-delete the row, leave the blob in place
   * (recoverable via HardDeleteArtifact on pangaea).
   *
   * @generated from field: bool delete_blob = 2;
   */ _define_property(this, "deleteBlob", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteArtifactRequest, "runtime", proto3);
_define_property(DeleteArtifactRequest, "typeName", "mono.artifact.v1.DeleteArtifactRequest");
_define_property(DeleteArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "delete_blob",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.DeleteArtifactResponse
 */ export class DeleteArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteArtifactResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteArtifactResponse, "runtime", proto3);
_define_property(DeleteArtifactResponse, "typeName", "mono.artifact.v1.DeleteArtifactResponse");
_define_property(DeleteArtifactResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.artifact.v1.DeleteChatDatasetsRequest
 */ export class DeleteChatDatasetsRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteChatDatasetsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteChatDatasetsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteChatDatasetsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteChatDatasetsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * The conversation id as shanks knows it; a "shanks-" prefix is ignored
   * when matching artifacts' chat_id.
   *
   * @generated from field: string conversation_id = 1;
   */ _define_property(this, "conversationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteChatDatasetsRequest, "runtime", proto3);
_define_property(DeleteChatDatasetsRequest, "typeName", "mono.artifact.v1.DeleteChatDatasetsRequest");
_define_property(DeleteChatDatasetsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "conversation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.DeleteChatDatasetsResponse
 */ export class DeleteChatDatasetsResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteChatDatasetsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteChatDatasetsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteChatDatasetsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteChatDatasetsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 deleted = 1;
   */ _define_property(this, "deleted", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteChatDatasetsResponse, "runtime", proto3);
_define_property(DeleteChatDatasetsResponse, "typeName", "mono.artifact.v1.DeleteChatDatasetsResponse");
_define_property(DeleteChatDatasetsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deleted",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.GenerateDownloadUrlRequest
 */ export class GenerateDownloadUrlRequest extends Message {
    static fromBinary(bytes, options) {
        return new GenerateDownloadUrlRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateDownloadUrlRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateDownloadUrlRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateDownloadUrlRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * Optional override of the default TTL (seconds). 0 = use service default.
   *
   * @generated from field: int32 ttl_seconds = 2;
   */ _define_property(this, "ttlSeconds", 0), /**
   * When true, returns a URL targeting the *processed* output (markdown/json)
   * for artifacts that have been through reverie. Falls back to the original
   * when no processed output exists.
   *
   * @generated from field: bool prefer_processed = 3;
   */ _define_property(this, "preferProcessed", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateDownloadUrlRequest, "runtime", proto3);
_define_property(GenerateDownloadUrlRequest, "typeName", "mono.artifact.v1.GenerateDownloadUrlRequest");
_define_property(GenerateDownloadUrlRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "ttl_seconds",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "prefer_processed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.GenerateDownloadUrlResponse
 */ export class GenerateDownloadUrlResponse extends Message {
    static fromBinary(bytes, options) {
        return new GenerateDownloadUrlResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateDownloadUrlResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateDownloadUrlResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateDownloadUrlResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string url = 1;
   */ _define_property(this, "url", ""), /**
   * @generated from field: google.protobuf.Timestamp expires_at = 2;
   */ _define_property(this, "expiresAt", void 0), /**
   * Echoed for client-side branching: gridfs URLs are tesoro-internal redirects
   * (or empty, signalling "fall through to legacy handler").
   *
   * @generated from field: mono.artifact.v1.StorageProvider storage_provider = 3;
   */ _define_property(this, "storageProvider", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateDownloadUrlResponse, "runtime", proto3);
_define_property(GenerateDownloadUrlResponse, "typeName", "mono.artifact.v1.GenerateDownloadUrlResponse");
_define_property(GenerateDownloadUrlResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "expires_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "storage_provider",
            kind: "enum",
            T: proto3.getEnumType(StorageProvider)
        }
    ]));
/**
 * @generated from message mono.artifact.v1.GetArtifactChunkRequest
 */ export class GetArtifactChunkRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetArtifactChunkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetArtifactChunkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetArtifactChunkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetArtifactChunkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * chunk_kind selects which slice to return.
   *   "processed_markdown" : the processed output, if any.
   *   "sheet_preview"      : the first preview window of a spreadsheet.
   *   "sheet_chunk"        : a row/col range; requires range_* fields.
   *   "sheet_manifest"     : sheet metadata (sheet names, row/col counts).
   *
   * @generated from field: string chunk_kind = 2;
   */ _define_property(this, "chunkKind", ""), /**
   * Optional: index of the spreadsheet sheet (0-based).
   *
   * @generated from field: int32 sheet_index = 3;
   */ _define_property(this, "sheetIndex", 0), /**
   * @generated from field: int32 range_row_start = 4;
   */ _define_property(this, "rangeRowStart", 0), /**
   * @generated from field: int32 range_row_end = 5;
   */ _define_property(this, "rangeRowEnd", 0), /**
   * @generated from field: int32 range_col_start = 6;
   */ _define_property(this, "rangeColStart", 0), /**
   * @generated from field: int32 range_col_end = 7;
   */ _define_property(this, "rangeColEnd", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetArtifactChunkRequest, "runtime", proto3);
_define_property(GetArtifactChunkRequest, "typeName", "mono.artifact.v1.GetArtifactChunkRequest");
_define_property(GetArtifactChunkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "chunk_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sheet_index",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "range_row_start",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "range_row_end",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "range_col_start",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "range_col_end",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.GetArtifactChunkResponse
 */ export class GetArtifactChunkResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetArtifactChunkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetArtifactChunkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetArtifactChunkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetArtifactChunkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bytes data = 1;
   */ _define_property(this, "data", new Uint8Array(0)), /**
   * @generated from field: string content_type = 2;
   */ _define_property(this, "contentType", ""), /**
   * Free-form metadata (e.g. sheet manifest JSON, total row count).
   *
   * @generated from field: google.protobuf.Struct metadata = 3;
   */ _define_property(this, "metadata", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetArtifactChunkResponse, "runtime", proto3);
_define_property(GetArtifactChunkResponse, "typeName", "mono.artifact.v1.GetArtifactChunkResponse");
_define_property(GetArtifactChunkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 2,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "metadata",
            kind: "message",
            T: Struct
        }
    ]));
/**
 * @generated from message mono.artifact.v1.StartArtifactProcessingRequest
 */ export class StartArtifactProcessingRequest extends Message {
    static fromBinary(bytes, options) {
        return new StartArtifactProcessingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartArtifactProcessingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartArtifactProcessingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartArtifactProcessingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string requested_by_user_id = 2;
   */ _define_property(this, "requestedByUserId", ""), /**
   * Forwarded as ProcessDocumentRequest.options.
   *
   * @generated from field: google.protobuf.Struct processing_options = 3;
   */ _define_property(this, "processingOptions", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StartArtifactProcessingRequest, "runtime", proto3);
_define_property(StartArtifactProcessingRequest, "typeName", "mono.artifact.v1.StartArtifactProcessingRequest");
_define_property(StartArtifactProcessingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "requested_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "processing_options",
            kind: "message",
            T: Struct
        }
    ]));
/**
 * @generated from message mono.artifact.v1.StartArtifactProcessingResponse
 */ export class StartArtifactProcessingResponse extends Message {
    static fromBinary(bytes, options) {
        return new StartArtifactProcessingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartArtifactProcessingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartArtifactProcessingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartArtifactProcessingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.artifact.v1.ProcessingJob job = 1;
   */ _define_property(this, "job", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StartArtifactProcessingResponse, "runtime", proto3);
_define_property(StartArtifactProcessingResponse, "typeName", "mono.artifact.v1.StartArtifactProcessingResponse");
_define_property(StartArtifactProcessingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job",
            kind: "message",
            T: ProcessingJob
        }
    ]));
/**
 * @generated from message mono.artifact.v1.GetProcessingJobRequest
 */ export class GetProcessingJobRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProcessingJobRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProcessingJobRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProcessingJobRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProcessingJobRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string job_id = 1;
   */ _define_property(this, "jobId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProcessingJobRequest, "runtime", proto3);
_define_property(GetProcessingJobRequest, "typeName", "mono.artifact.v1.GetProcessingJobRequest");
_define_property(GetProcessingJobRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.GetProcessingJobResponse
 */ export class GetProcessingJobResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProcessingJobResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProcessingJobResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProcessingJobResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProcessingJobResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.artifact.v1.ProcessingJob job = 1;
   */ _define_property(this, "job", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProcessingJobResponse, "runtime", proto3);
_define_property(GetProcessingJobResponse, "typeName", "mono.artifact.v1.GetProcessingJobResponse");
_define_property(GetProcessingJobResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job",
            kind: "message",
            T: ProcessingJob
        }
    ]));
/**
 * @generated from message mono.artifact.v1.CancelProcessingJobRequest
 */ export class CancelProcessingJobRequest extends Message {
    static fromBinary(bytes, options) {
        return new CancelProcessingJobRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CancelProcessingJobRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CancelProcessingJobRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CancelProcessingJobRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string job_id = 1;
   */ _define_property(this, "jobId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CancelProcessingJobRequest, "runtime", proto3);
_define_property(CancelProcessingJobRequest, "typeName", "mono.artifact.v1.CancelProcessingJobRequest");
_define_property(CancelProcessingJobRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.CancelProcessingJobResponse
 */ export class CancelProcessingJobResponse extends Message {
    static fromBinary(bytes, options) {
        return new CancelProcessingJobResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CancelProcessingJobResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CancelProcessingJobResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CancelProcessingJobResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.artifact.v1.ProcessingJob job = 1;
   */ _define_property(this, "job", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CancelProcessingJobResponse, "runtime", proto3);
_define_property(CancelProcessingJobResponse, "typeName", "mono.artifact.v1.CancelProcessingJobResponse");
_define_property(CancelProcessingJobResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job",
            kind: "message",
            T: ProcessingJob
        }
    ]));
/**
 * @generated from message mono.artifact.v1.RetryProcessingRequest
 */ export class RetryProcessingRequest extends Message {
    static fromBinary(bytes, options) {
        return new RetryProcessingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetryProcessingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetryProcessingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetryProcessingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * The failed job to retry. The artifact is resolved from this job's
   * artifact_id; callers don't need to pass it separately.
   *
   * @generated from field: string job_id = 1;
   */ _define_property(this, "jobId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetryProcessingRequest, "runtime", proto3);
_define_property(RetryProcessingRequest, "typeName", "mono.artifact.v1.RetryProcessingRequest");
_define_property(RetryProcessingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.RetryProcessingResponse
 */ export class RetryProcessingResponse extends Message {
    static fromBinary(bytes, options) {
        return new RetryProcessingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetryProcessingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetryProcessingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetryProcessingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * The NEW processing job (with a new job_id). The original failed job
   * remains in pangaea unchanged.
   *
   * @generated from field: mono.artifact.v1.ProcessingJob job = 1;
   */ _define_property(this, "job", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetryProcessingResponse, "runtime", proto3);
_define_property(RetryProcessingResponse, "typeName", "mono.artifact.v1.RetryProcessingResponse");
_define_property(RetryProcessingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job",
            kind: "message",
            T: ProcessingJob
        }
    ]));
/**
 * @generated from message mono.artifact.v1.ListProcessingJobsRequest
 */ export class ListProcessingJobsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProcessingJobsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProcessingJobsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProcessingJobsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProcessingJobsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * artifact_id is required — the result set must be bounded to a single
   * artifact so the tenant check is enforceable (processing jobs do not
   * carry tenant_id in pangaea; a bare list would leak across tenants).
   *
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * Optional narrowing to one of the artifact's project associations.
   *
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * Optional narrowing.
   *
   * @generated from field: mono.artifact.v1.ProcessingStatus status = 3;
   */ _define_property(this, "status", 0), /**
   * @generated from field: int32 offset = 4;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 5;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProcessingJobsRequest, "runtime", proto3);
_define_property(ListProcessingJobsRequest, "typeName", "mono.artifact.v1.ListProcessingJobsRequest");
_define_property(ListProcessingJobsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "status",
            kind: "enum",
            T: proto3.getEnumType(ProcessingStatus)
        },
        {
            no: 4,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.ListProcessingJobsResponse
 */ export class ListProcessingJobsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProcessingJobsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProcessingJobsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProcessingJobsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProcessingJobsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.artifact.v1.ProcessingJob jobs = 1;
   */ _define_property(this, "jobs", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProcessingJobsResponse, "runtime", proto3);
_define_property(ListProcessingJobsResponse, "typeName", "mono.artifact.v1.ListProcessingJobsResponse");
_define_property(ListProcessingJobsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "jobs",
            kind: "message",
            T: ProcessingJob,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.TagArtifactToProjectRequest
 */ export class TagArtifactToProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new TagArtifactToProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TagArtifactToProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TagArtifactToProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TagArtifactToProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TagArtifactToProjectRequest, "runtime", proto3);
_define_property(TagArtifactToProjectRequest, "typeName", "mono.artifact.v1.TagArtifactToProjectRequest");
_define_property(TagArtifactToProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.TagArtifactToProjectResponse
 */ export class TagArtifactToProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new TagArtifactToProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TagArtifactToProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TagArtifactToProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TagArtifactToProjectResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(TagArtifactToProjectResponse, "runtime", proto3);
_define_property(TagArtifactToProjectResponse, "typeName", "mono.artifact.v1.TagArtifactToProjectResponse");
_define_property(TagArtifactToProjectResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.artifact.v1.TagArtifactToOutlineRequest
 */ export class TagArtifactToOutlineRequest extends Message {
    static fromBinary(bytes, options) {
        return new TagArtifactToOutlineRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TagArtifactToOutlineRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TagArtifactToOutlineRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TagArtifactToOutlineRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string outline_node_id = 3;
   */ _define_property(this, "outlineNodeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TagArtifactToOutlineRequest, "runtime", proto3);
_define_property(TagArtifactToOutlineRequest, "typeName", "mono.artifact.v1.TagArtifactToOutlineRequest");
_define_property(TagArtifactToOutlineRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "outline_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.TagArtifactToOutlineResponse
 */ export class TagArtifactToOutlineResponse extends Message {
    static fromBinary(bytes, options) {
        return new TagArtifactToOutlineResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TagArtifactToOutlineResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TagArtifactToOutlineResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TagArtifactToOutlineResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(TagArtifactToOutlineResponse, "runtime", proto3);
_define_property(TagArtifactToOutlineResponse, "typeName", "mono.artifact.v1.TagArtifactToOutlineResponse");
_define_property(TagArtifactToOutlineResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.artifact.v1.GetProjectArtifactsRequest
 */ export class GetProjectArtifactsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProjectArtifactsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProjectArtifactsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProjectArtifactsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProjectArtifactsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * When set, only artifacts linked to this outline node are returned.
   *
   * @generated from field: string outline_node_id = 2;
   */ _define_property(this, "outlineNodeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProjectArtifactsRequest, "runtime", proto3);
_define_property(GetProjectArtifactsRequest, "typeName", "mono.artifact.v1.GetProjectArtifactsRequest");
_define_property(GetProjectArtifactsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "outline_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.GetProjectArtifactsResponse
 */ export class GetProjectArtifactsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProjectArtifactsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProjectArtifactsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProjectArtifactsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProjectArtifactsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.artifact.v1.Artifact artifacts = 1;
   */ _define_property(this, "artifacts", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProjectArtifactsResponse, "runtime", proto3);
_define_property(GetProjectArtifactsResponse, "typeName", "mono.artifact.v1.GetProjectArtifactsResponse");
_define_property(GetProjectArtifactsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifacts",
            kind: "message",
            T: Artifact,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.artifact.v1.LinkArtifactToEntityRequest
 */ export class LinkArtifactToEntityRequest extends Message {
    static fromBinary(bytes, options) {
        return new LinkArtifactToEntityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkArtifactToEntityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkArtifactToEntityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkArtifactToEntityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string entity_type = 2;
   */ _define_property(this, "entityType", ""), /**
   * @generated from field: string entity_id = 3;
   */ _define_property(this, "entityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkArtifactToEntityRequest, "runtime", proto3);
_define_property(LinkArtifactToEntityRequest, "typeName", "mono.artifact.v1.LinkArtifactToEntityRequest");
_define_property(LinkArtifactToEntityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "entity_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "entity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.LinkArtifactToEntityResponse
 */ export class LinkArtifactToEntityResponse extends Message {
    static fromBinary(bytes, options) {
        return new LinkArtifactToEntityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkArtifactToEntityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkArtifactToEntityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkArtifactToEntityResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkArtifactToEntityResponse, "runtime", proto3);
_define_property(LinkArtifactToEntityResponse, "typeName", "mono.artifact.v1.LinkArtifactToEntityResponse");
_define_property(LinkArtifactToEntityResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.artifact.v1.UnlinkArtifactFromEntityRequest
 */ export class UnlinkArtifactFromEntityRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkArtifactFromEntityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkArtifactFromEntityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkArtifactFromEntityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkArtifactFromEntityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string entity_type = 2;
   */ _define_property(this, "entityType", ""), /**
   * @generated from field: string entity_id = 3;
   */ _define_property(this, "entityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkArtifactFromEntityRequest, "runtime", proto3);
_define_property(UnlinkArtifactFromEntityRequest, "typeName", "mono.artifact.v1.UnlinkArtifactFromEntityRequest");
_define_property(UnlinkArtifactFromEntityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "entity_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "entity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.UnlinkArtifactFromEntityResponse
 */ export class UnlinkArtifactFromEntityResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkArtifactFromEntityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkArtifactFromEntityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkArtifactFromEntityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkArtifactFromEntityResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkArtifactFromEntityResponse, "runtime", proto3);
_define_property(UnlinkArtifactFromEntityResponse, "typeName", "mono.artifact.v1.UnlinkArtifactFromEntityResponse");
_define_property(UnlinkArtifactFromEntityResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.artifact.v1.ListEntityArtifactsRequest
 */ export class ListEntityArtifactsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListEntityArtifactsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListEntityArtifactsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListEntityArtifactsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListEntityArtifactsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string entity_type = 1;
   */ _define_property(this, "entityType", ""), /**
   * @generated from field: string entity_id = 2;
   */ _define_property(this, "entityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListEntityArtifactsRequest, "runtime", proto3);
_define_property(ListEntityArtifactsRequest, "typeName", "mono.artifact.v1.ListEntityArtifactsRequest");
_define_property(ListEntityArtifactsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entity_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "entity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.ListEntityArtifactsResponse
 */ export class ListEntityArtifactsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListEntityArtifactsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListEntityArtifactsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListEntityArtifactsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListEntityArtifactsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.artifact.v1.Artifact artifacts = 1;
   */ _define_property(this, "artifacts", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListEntityArtifactsResponse, "runtime", proto3);
_define_property(ListEntityArtifactsResponse, "typeName", "mono.artifact.v1.ListEntityArtifactsResponse");
_define_property(ListEntityArtifactsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifacts",
            kind: "message",
            T: Artifact,
            repeated: true
        }
    ]));
/**
 * ClassifyArtifact updates the user-facing classification (document type +
 * free-form label) on an artifact the caller's tenant owns.
 *
 * @generated from message mono.artifact.v1.ClassifyArtifactRequest
 */ export class ClassifyArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new ClassifyArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClassifyArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClassifyArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClassifyArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string document_type = 2;
   */ _define_property(this, "documentType", ""), /**
   * @generated from field: string classification_label = 3;
   */ _define_property(this, "classificationLabel", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClassifyArtifactRequest, "runtime", proto3);
_define_property(ClassifyArtifactRequest, "typeName", "mono.artifact.v1.ClassifyArtifactRequest");
_define_property(ClassifyArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "classification_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.ClassifyArtifactResponse
 */ export class ClassifyArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new ClassifyArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClassifyArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClassifyArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClassifyArtifactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.artifact.v1.Artifact artifact = 1;
   */ _define_property(this, "artifact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClassifyArtifactResponse, "runtime", proto3);
_define_property(ClassifyArtifactResponse, "typeName", "mono.artifact.v1.ClassifyArtifactResponse");
_define_property(ClassifyArtifactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: Artifact
        }
    ]));
/**
 * ChatArtifactSummary is one row of the Artifacts tab list — the newest version
 * of a document. `id` is the DOCUMENT id (stable across versions), not the
 * version-row id, because that is what every downstream call keys on.
 *
 * @generated from message mono.artifact.v1.ChatArtifactSummary
 */ export class ChatArtifactSummary extends Message {
    static fromBinary(bytes, options) {
        return new ChatArtifactSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChatArtifactSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChatArtifactSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChatArtifactSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * text | code | image | sheet | presentation
   *
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string chat_id = 4;
   */ _define_property(this, "chatId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ChatArtifactSummary, "runtime", proto3);
_define_property(ChatArtifactSummary, "typeName", "mono.artifact.v1.ChatArtifactSummary");
_define_property(ChatArtifactSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * ChatArtifactVersion carries the document body. Content is fetched from MinIO
 * by the handler; it is not stored in Postgres.
 *
 * @generated from message mono.artifact.v1.ChatArtifactVersion
 */ export class ChatArtifactVersion extends Message {
    static fromBinary(bytes, options) {
        return new ChatArtifactVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChatArtifactVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChatArtifactVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChatArtifactVersion, a, b);
    }
    constructor(data){
        super(), /**
   * The version-row id.
   *
   * @generated from field: string version_id = 1;
   */ _define_property(this, "versionId", ""), /**
   * The document id — stable across versions.
   *
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string kind = 4;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string content = 5;
   */ _define_property(this, "content", ""), /**
   * A user id, or the literal "ai".
   *
   * @generated from field: string created_by = 6;
   */ _define_property(this, "createdBy", ""), /**
   * create | update | ai_edit | user_edit | revert
   *
   * @generated from field: string change_type = 7;
   */ _define_property(this, "changeType", ""), /**
   * @generated from field: string change_description = 8;
   */ _define_property(this, "changeDescription", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ChatArtifactVersion, "runtime", proto3);
_define_property(ChatArtifactVersion, "typeName", "mono.artifact.v1.ChatArtifactVersion");
_define_property(ChatArtifactVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "change_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "change_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.artifact.v1.ListChatArtifactsRequest
 */ export class ListChatArtifactsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListChatArtifactsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListChatArtifactsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListChatArtifactsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListChatArtifactsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Tenant and owner are taken from the gateway principal, never the request —
   * a client-supplied owner would defeat the ownership policy.
   *
   * @generated from field: repeated string kinds = 1;
   */ _define_property(this, "kinds", []), /**
   * @generated from field: string search = 2;
   */ _define_property(this, "search", ""), /**
   * recent (default) | oldest | title
   *
   * @generated from field: string sort_by = 3;
   */ _define_property(this, "sortBy", ""), /**
   * @generated from field: int64 offset = 4;
   */ _define_property(this, "offset", protoInt64.zero), /**
   * @generated from field: int64 limit = 5;
   */ _define_property(this, "limit", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListChatArtifactsRequest, "runtime", proto3);
_define_property(ListChatArtifactsRequest, "typeName", "mono.artifact.v1.ListChatArtifactsRequest");
_define_property(ListChatArtifactsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kinds",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 2,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sort_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "offset",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "limit",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.ListChatArtifactsResponse
 */ export class ListChatArtifactsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListChatArtifactsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListChatArtifactsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListChatArtifactsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListChatArtifactsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.artifact.v1.ChatArtifactSummary artifacts = 1;
   */ _define_property(this, "artifacts", []), /**
   * Count of documents, not version rows.
   *
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListChatArtifactsResponse, "runtime", proto3);
_define_property(ListChatArtifactsResponse, "typeName", "mono.artifact.v1.ListChatArtifactsResponse");
_define_property(ListChatArtifactsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifacts",
            kind: "message",
            T: ChatArtifactSummary,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.GetChatArtifactRequest
 */ export class GetChatArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetChatArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetChatArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetChatArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetChatArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: int64 versions_offset = 2;
   */ _define_property(this, "versionsOffset", protoInt64.zero), /**
   * @generated from field: int64 versions_limit = 3;
   */ _define_property(this, "versionsLimit", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetChatArtifactRequest, "runtime", proto3);
_define_property(GetChatArtifactRequest, "typeName", "mono.artifact.v1.GetChatArtifactRequest");
_define_property(GetChatArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "versions_offset",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "versions_limit",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.GetChatArtifactResponse
 */ export class GetChatArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetChatArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetChatArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetChatArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetChatArtifactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.artifact.v1.ChatArtifactVersion latest = 1;
   */ _define_property(this, "latest", void 0), /**
   * @generated from field: repeated mono.artifact.v1.ChatArtifactVersion versions = 2;
   */ _define_property(this, "versions", []), /**
   * @generated from field: int64 versions_total = 3;
   */ _define_property(this, "versionsTotal", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetChatArtifactResponse, "runtime", proto3);
_define_property(GetChatArtifactResponse, "typeName", "mono.artifact.v1.GetChatArtifactResponse");
_define_property(GetChatArtifactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "latest",
            kind: "message",
            T: ChatArtifactVersion
        },
        {
            no: 2,
            name: "versions",
            kind: "message",
            T: ChatArtifactVersion,
            repeated: true
        },
        {
            no: 3,
            name: "versions_total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.SaveChatArtifactRequest
 */ export class SaveChatArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveChatArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveChatArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveChatArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveChatArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Empty or unknown => create a new document. Known => append a version.
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string content = 4;
   */ _define_property(this, "content", ""), /**
   * @generated from field: string chat_id = 5;
   */ _define_property(this, "chatId", ""), /**
   * @generated from field: string change_description = 6;
   */ _define_property(this, "changeDescription", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveChatArtifactRequest, "runtime", proto3);
_define_property(SaveChatArtifactRequest, "typeName", "mono.artifact.v1.SaveChatArtifactRequest");
_define_property(SaveChatArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "chat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "change_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.SaveChatArtifactResponse
 */ export class SaveChatArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveChatArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveChatArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveChatArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveChatArtifactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.artifact.v1.ChatArtifactVersion artifact = 1;
   */ _define_property(this, "artifact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveChatArtifactResponse, "runtime", proto3);
_define_property(SaveChatArtifactResponse, "typeName", "mono.artifact.v1.SaveChatArtifactResponse");
_define_property(SaveChatArtifactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: ChatArtifactVersion
        }
    ]));
/**
 * @generated from message mono.artifact.v1.DeleteChatArtifactRequest
 */ export class DeleteChatArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteChatArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteChatArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteChatArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteChatArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * The document id (stable across versions), not a version-row id.
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteChatArtifactRequest, "runtime", proto3);
_define_property(DeleteChatArtifactRequest, "typeName", "mono.artifact.v1.DeleteChatArtifactRequest");
_define_property(DeleteChatArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifact.v1.DeleteChatArtifactResponse
 */ export class DeleteChatArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteChatArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteChatArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteChatArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteChatArtifactResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteChatArtifactResponse, "runtime", proto3);
_define_property(DeleteChatArtifactResponse, "typeName", "mono.artifact.v1.DeleteChatArtifactResponse");
_define_property(DeleteChatArtifactResponse, "fields", proto3.util.newFieldList(()=>[]));
